import { createFileRoute, redirect } from "@tanstack/react-router";

// The dropzone now lives on the statements registry page.
export const Route = createFileRoute("/_authed/statements/upload")({
  beforeLoad: () => {
    throw redirect({ to: "/statements" });
  },
});
